@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
<div
  class="projectable-form-wrapper frontdoor-form share-form-page"
  (keyup.enter)="save($event)"
  (keyup.escape)="closeModal(false)"
  >
  <lib-form-header
    [data]="formData"
    [title]="isExistingEntity ? 'View Http Share: ' : 'Create New Http Share'"
    [moreActions]="moreActions"
    (actionRequested)="headerActionRequested($event)"
    [(formView)]="formView"
  ></lib-form-header>
  <div class="integration-form-container projectable-form-container">
    @if (formView === 'simple') {
      <div class="share-layout form-group-row">
        <div class="share-row">
          <div class="form-group-column half">
            <lib-form-field-container [title]="'Share Details'">
              <div class="stacked-fields">

                <div class="field-row" [class.frontdoor-error-field]="namespaceError">
                  <div class="field-label">
                    <span class="frontdoor-inline-error-group">
                      Namespace
                      @if (!isEditing) {
                        <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="namespaceError">
                          {{ namespaceErrorMessage || 'Invalid value' }}
                        </span>
                      }
                    </span>
                    @if (!isEditing) { <span class="field-label-suffix">OPTIONAL</span> }
                  </div>
                  @if (!isEditing) {
                    <app-filter-select
                      [options]="namespaceList"
                      [(ngModel)]="formData.namespaceId"
                      placeholder="Select a Namespace"
                      optionValue="id"
                      optionLabel="name"
                      [disabled]="isEditing"
                    ></app-filter-select>
                  }
                  @if (isEditing) {
                    <span class="field-value">{{namespace}}</span>
                  }
                </div>

                <div class="field-row" [class.frontdoor-error-field]="nameError">
                  <div class="field-label">
                    <span class="frontdoor-inline-error-group">
                      Name
                      <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="nameError">
                        {{ nameErrorMessage || 'Must not be blank' }}
                      </span>
                    </span>
                  </div>
                  <input
                    class="form-field-input"
                    placeholder="Add your http share name."
                    [ngClass]="{error: errMap['domainName'] || errMap['nameRequired']}"
                    [(ngModel)]="formData.name"
                    autofocus
                    #nameFieldInput
                  />
                </div>

                <div class="field-row" [class.frontdoor-error-field]="agentError">
                  <div class="field-label">
                    <span class="frontdoor-inline-error-group">
                      Hosting Frontdoor Agent
                      <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="agentError">
                        {{ agentErrorMessage || 'Select an agent' }}
                      </span>
                    </span>
                  </div>
                  <app-filter-select
                    [options]="agentList"
                    [(ngModel)]="formData.envId"
                    placeholder="Select an Agent"
                    optionValue="zId"
                    optionLabel="description"
                    style="color: var(--tableText)"
                  ></app-filter-select>
                </div>

                <div class="field-row" [class.frontdoor-error-field]="targetError">
                  <div class="field-label">
                    <span class="frontdoor-inline-error-group">
                      Target URL
                      <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="targetError">
                        {{ targetErrorMessage || 'Enter a target URL' }}
                      </span>
                    </span>
                  </div>
                  <input
                    [(ngModel)]="formData.target"
                    placeholder="Enter your target URL"
                  />
                </div>

              </div>
            </lib-form-field-container>
          </div>

          <div class="form-group-column half">
            <lib-form-field-container [title]="'Security & Health'">
              <div class="stacked-fields">

                <div class="field-row">
                  <div class="field-label">
                    Authentication Provider
                    <span class="field-label-suffix">{{ errMap['name'] ? 'INVALID' : 'OPTIONAL' }}</span>
                  </div>
                  @if (!showAuthLabel) {
                    <app-filter-select
                      [options]="providerList"
                      [(ngModel)]="formData.authProviderId"
                      optionValue="id"
                      optionLabel="name"
                      placeholder="Select a Provider"
                    ></app-filter-select>
                  }
                  @if (showAuthLabel) {
                    <span>{{authProviderLabel}} <a routerLink="/frontdoor/authentication-providers/create">here</a></span>
                  }
                </div>

                @if (formData.authProviderId) {
                  <div class="field-row">
                    <div class="field-label">Email Filters</div>
                    <app-chips-input
                      (keydown)="onKeyDown($event)"
                      (keyup.enter)="$event.stopPropagation()"
                      (keyup.space)="$event.stopPropagation()"
                      [allowDuplicate]="false"
                      [placeholder]="'Optionally add email filters here.'"
                      addOnBlur="true"
                      separator=","
                      (paste)="paste($event)"
                    ></app-chips-input>
                  </div>
                }

                <div class="field-row">
                  <div class="field-label">Skip Target Certificate Validation</div>
                  <div class="switchGrid special">
                    <div
                      (click)="toggleInsecure()"
                      [ngClass]="{ on: formData.insecure }"
                      class="toggle"
                    >
                      <span [hidden]="!formData.insecure">ON&nbsp;&nbsp;&nbsp;</span>
                      <span [hidden]="formData.insecure">&nbsp;&nbsp;&nbsp;&nbsp;OFF</span>
                      <div class="switch"></div>
                    </div>
                  </div>
                </div>

                @if (isEditing) {
                  <div class="field-row">
                    <div class="field-label">Health Checks</div>
                    @if (!showHealthCheckLabel) {
                      <mat-list>
                        <mat-list-item *ngFor="let check of healthChecks">
                          <span matListItemTitle>{{ check.name }}</span>
                        </mat-list-item>
                      </mat-list>
                    }
                    @if (showHealthCheckLabel) {
                      <span>{{healthCheckLabel}} <a routerLink="/frontdoor/health-checks/create">here</a></span>
                    }
                  </div>
                }

              </div>
            </lib-form-field-container>
          </div>
        </div>

        @if (isEditing) {
          <div class="share-row">
            <div class="form-group-column full">
              <lib-form-field-container [title]="'Metrics'">
                <app-rx-tx-timeline
                  [samples]="metricSamples"
                  [loading]="metricsLoading"
                  height="14rem"
                ></app-rx-tx-timeline>
              </lib-form-field-container>
            </div>
          </div>
        }
      </div>
    }
    @if (formView === 'raw') {
      <div class="form-group-column">
        @if (formData) {
          <lib-json-view [(data)]="formData"></lib-json-view>
        }
      </div>
    }

  </div>
